// Wraps product pages with brand-scoped theme (data-product-theme).
import React from "react";
import { ProductThemeProvider } from "../../contexts/ProductThemeContext";

const ProductThemeShell = ({ children, themeId }) => (
  <ProductThemeProvider themeId={themeId}>{children}</ProductThemeProvider>
);

export default ProductThemeShell;
